/**
 * Internal dependencies
 */
import type { Session } from '../../types';

export function isAlternativeDistributionAllowed( session: Session ): boolean {
	return session.experiments.some( ( e ) => e.alternativeCuts );
}
